/** Navigate to a push/email deeplink (same-origin full URL with hash route). */
export function openNotificationDeeplink(url: string): void {
  window.location.href = url;
}

/** Listen for background-notification clicks from firebase-messaging-sw.js. */
export function initNotificationClickListener(): () => void {
  if (!('serviceWorker' in navigator)) {
    return () => {};
  }
  const onMessage = (event: MessageEvent) => {
    const data = event.data;
    if (data?.type === 'notification-click' && typeof data.url === 'string') {
      openNotificationDeeplink(data.url);
    }
  };
  navigator.serviceWorker.addEventListener('message', onMessage);
  return () => {
    navigator.serviceWorker.removeEventListener('message', onMessage);
  };
}
